import Vue from 'vue'
const state = {}
  // getters
const getters = {
	getRegistInfo: state => {	
        return state.registInfo;
    }
}  // actions
const actions = {   //异步
    getRegistInfo({commit},arg) { // commit 提交；name即为点击后传递过来的参数
    	if(arg){
	    	commit ('getRegistInfo', arg);
    	}else{
    		axios({
		        url: P.ajaxUrl+"/supplier/info",		        
		        method: 'post',
		        type: 'json',
		    }).then((data) => {
		      	let D = data.data;	      	
		      	if(D.resultCode == 0){
		      		commit ('getRegistInfo', D.data);
		      	}else{		      		
		      		console.log(data.resultMessage)
		      	}
		    });
    	}
	}
}// mutations
const mutations = {
    getRegistInfo (state, arg) {    	
    	Vue.set(state, "registInfo", arg); //设置属性需要使用vue.set 才能触发 getters
    }
}
  
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/registinfo.js